import { render, staticRenderFns } from "./detail-pengajuan-skripsi.vue?vue&type=template&id=69f2345c"
import script from "./detail-pengajuan-skripsi.vue?vue&type=script&lang=js"
export * from "./detail-pengajuan-skripsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports